var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Image{\r\n    background: url(" + escape(require("../img/IH01_nomadd.jpg")) + ") no-repeat center center;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-size: cover;\r\n}\r\n\r\n@media all and (orientation:landscape) {\r\n    .Image{\r\n\r\n    }\r\n}", ""]);

// exports
